import { createContext, useContext } from 'react';
import type { SearchableFormValues } from 'components/SearchableFilter';
import type { ManagementQueryParams } from '../Management';

export type ManagementPageContextType = {
  isFiltersDirty: boolean;
  pageParams: ManagementQueryParams;
  setPageParams: React.Dispatch<React.SetStateAction<ManagementQueryParams>>;
  handleChangeOemSegmentsFilter: (opts: SearchableFormValues) => void;
  handleChangeTeamsFilter: (opts: SearchableFormValues) => void;
  handleChangeAccountsFilter: (opts: SearchableFormValues) => void;
  handleChangeDepotsFilter: (opts: SearchableFormValues) => void;
  handleClearFilters: () => void;
};

export const ManagementPageContext = createContext(
  {} as ManagementPageContextType,
);

export const useManagementPageContext = () => useContext(ManagementPageContext);
